import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { jsx as _jsx } from "react/jsx-runtime";
const CurrentPlanButton = ({
  ctaStyles,
  productLine
}) => {
  const message = productLine ? `ebxInterstitialPage.comparisonFeatureTable.yourPlanCta.${productLine.toLowerCase()}` : 'suiteFeatureTable.currentPlan';
  return /*#__PURE__*/_jsx(UIButton, {
    disabled: true,
    style: ctaStyles,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    })
  });
};
export default CurrentPlanButton;